import { useCallback, useEffect, useState } from "react";
import { format, startOfMonth } from "date-fns";
import { getWordOfTheDay } from "../../../../services/StudentPortal/StudentWordOfTheDayService";
import { unwrapList } from "../../utils/studentPortalUtils";
import { handleApiError } from "../../../../utils/errorHandler";

// Confirmed against the real backend (2026-10-31): current_date is required
// — omitting it 422s. So instead of dropping the filter, the page now lets
// the student pick which date's current_date to fetch via a calendar
// (defaulting to today), rather than being stuck on just today's word.
export const useStudentWordOfTheDay = (studentId) => {
  const [selectedDate, setSelectedDate] = useState(() => new Date());
  const [month, setMonth] = useState(() => startOfMonth(new Date()));
  const [words, setWords] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchWords = useCallback(async () => {
    if (!studentId) return;
    setIsLoading(true);
    try {
      const response = await getWordOfTheDay({
        student_id: studentId,
        current_date: format(selectedDate, "yyyy-MM-dd"),
      });
      setWords(unwrapList(response));
    } catch (error) {
      handleApiError(error);
      setWords([]);
    } finally {
      setIsLoading(false);
    }
  }, [studentId, selectedDate]);

  useEffect(() => {
    fetchWords();
  }, [fetchWords]);

  const selectDate = (date) => {
    setSelectedDate(date);
    setMonth(startOfMonth(date));
  };

  return { words, isLoading, selectedDate, selectDate, month, setMonth };
};

export default useStudentWordOfTheDay;
